import React from 'react';
import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';

const FooterLink = ({ name, href, external, className = '' }) => {
  const baseClass =
    `text-sm text-gray-600 dark:text-gray-400 hover:text-accent transition-colors duration-200 inline-flex items-center gap-1 ${className}`.trim();

  if (external) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={baseClass}
      >
        {name}
        <ExternalLink className="w-3 h-3" />
      </a>
    );
  }

  return (
    <Link to={href} className={baseClass}>
      {name}
    </Link>
  );
};

export default FooterLink;
